import React from 'react'
import PropTypes from 'prop-types'
import { currencyFormat } from 'utils/format'
import { Visibility } from '@material-ui/icons'
import { Button } from 'ui-components/Button'
import { DescItemList } from 'ui-components/DescItemList'
import { StyledNumber } from 'ui-components/StyledNumber'
import { DescList } from 'ui-components/DescList'
import { Container, GroupStock, GroupPrice } from './styles'

export default function Product({ product, onClick }) {
  const {
    product_stock_attributes: stock,
    name,
    selling_price: sellingPrice,
  } = product.attributes

  const handleClick = () => {
    onClick(product.id)
  }

  return (
    <DescList>
      <Container>
        <DescItemList label="Nome">
          {name}
        </DescItemList>

        <GroupStock>
          <DescItemList label="Qtd.Atual">
            <StyledNumber number={stock.available} />
          </DescItemList>
          <DescItemList label="Qtd.Mínima">
            {stock.minimum_quantity}
          </DescItemList>
        </GroupStock>

        <GroupPrice>
          <DescItemList label="R$ Venda">
            {currencyFormat(sellingPrice)}
          </DescItemList>
          <Button buttonType="icon" onClick={handleClick}>
            <Visibility />
          </Button>
        </GroupPrice>
      </Container>
    </DescList>
  )
}

Product.propTypes = {
  product: PropTypes.objectOf(PropTypes.any).isRequired,
  onClick: PropTypes.func.isRequired,
}
